import { ReactNode } from "react";

export default function FormCard({ children }: { children: ReactNode }) {
  return (
    <div className="py-6 px-5 h-full grid grid-cols-4 gap-1 bg-white  rounded-lg">
      {children}
    </div>
  );
}
